import gql from "graphql-tag";
import LockableCommentFields from "../../fragments/LockableCommentFields";

export default gql`
  mutation LockAssetDiscussionComment($commentId: ObjectID!) {
    lockAssetDiscussionComment(commentId: $commentId) {
      __typename
      _id
      ...LockableCommentFields
    }
  }

  ${LockableCommentFields}
`;
